import { render, staticRenderFns } from "./menuSetLevel2.vue?vue&type=template&id=ba3e2676&scoped=true"
import script from "./menuSetLevel2.vue?vue&type=script&lang=js"
export * from "./menuSetLevel2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba3e2676",
  null
  
)

export default component.exports